export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "輸入新密碼",
        "Empty": "空",
        "No data": "無資料",
        //"Installation Package List": "安裝套件清單",
        "Update Package": "更新套件",

        "Settings - Profiles": "設定 - 設定檔",
        "User Management": "使用者管理",
        "Operation Records": "操作記錄",
        "Exit": "退出",
        "Total pages:": "總頁數：",
        "page": "頁",
        "Go to": "前往",
        "Prev": "上一頁",
        "Next": "下一頁",
        "per page": "每頁",
        "items": "條",
        "Please enter the page number to go to": "请输入前往页数",
        "Language": "語言",
        "Profile Picture": "設定檔圖片",
        "Old Password": "舊密碼",
        "New Password": "新密碼",
        "Confirm Password": "確認新密碼",
        "The two passwords entered do not match": "輸入的兩個密碼不相符",
        "Enter the new password again": "請再次輸入新密碼",
        "This must match the new password above": "必須與上方的新密碼一致",
        "Invalid input。Password length must be 8–16 characters": "無效的輸入。密碼長度必須為 8–16 個字元",
        "Lenovo Privacy Statement": "Lenovo 隱私權聲明",
        "Lenovo Software License Agreement": "Lenovo 軟體授權合約",
        //"Third-Party Notice": "協力廠商通知",
        "Third-Party Notice": "第三方通知",
        "Change Password": "變更密碼",
        "Edit Profile": "編輯設定檔",
        "Exited successfully": "已成功退出",
        "Admin": "管理員",
        "Common user": "一般使用者",
        "Super Admin":"超級管理員",
        "Model": "型號",
        "Are you sure you want to delete this?": "您確定要刪除此項目嗎？",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "輸入新密碼。它必須至少包含以下三項：大寫字母、小寫字母、數字和特殊字元",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "它必須至少包含以下三項：大寫字母、小寫字母、數字和特殊字元",
        "Tip": "提示",
        "Confirm": "确 認",
        "Cancel": "取 消",
        "Deletion successful": "删除成功",
        "Password changed successfully": "已成功變更密碼",
        "The file to upload is larger than 100 MB。 Please select another one。": "要上傳的檔案大於 100 MB。請選取另一個。",
        "Your session has expired。 Please log in again。": "您的階段作業已過期。請重新登入。",
        "Invalid network request URL。": "無效的網路要求 URL。",
        "Unknown server error。": "未知的伺服器錯誤。",
        "An unknown error has occurred": "發生未知錯誤!",
        "Request timeout。 Please check your network and try again。": "要求逾時。請檢查您的網路，然後重試。",
        "Failed to connect to server": "無法連接到伺服器",
        "Your network may be currently disconnected": "您的網路目前可能已中斷連線",
        "No related device found": "没有找到相关设备",
        "Pre-upgrade component not found in the device": "设备中预升级组件未找到",
        "FWID of the installation component not found": "安装组件FWID未找到",
        "Failed to set upgrade information": "升级信息设置失败",
        "Failed to set specified update options": "指定更新设置失败",
        "Failed to install the update package": "更新包安装失败",
        "Failed to obtain the device handle": "设备句柄获取失败",
        "Upgrade device mismatch": "升级设备不匹配",
        "Installation failed: Pre-upgrade component not found in the device": "无法安装:设备中没有找到预升级组件",
        "Installation failed: FWID mismatch in the component list": "无法安装:组件中FWID不匹配",
        "Installation failed: No matching monitor found for upgrade": "无法安装:未找到升级匹配的显示器",
        "The monitor does not exist": "顯示器不存在",
        "The command has been sent": "指令已傳送",
        "The group does not exist": "群組不存在",
        "The command does not exist": "指令不存在",
        "Setting does not exist": "设置不存在",
        "The settings profile does not exist": "設定檔不存在",
        "The update package does not exist": "更新套件不存在",
        "The update package record does not exist": "更新套件記錄不存在",
        "Invalid password format。 It must be between 8 and 30 characters long。": "無效的密碼格式。長度必須在 8 到 30 個字元之間",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "欄位為空",
        "Update time cannot be null": "陞級時間不能為空",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "無效的更新時間。它不能早於目前時間，也不能超出未來 30 天的範圍。",
        "Uploaded file is null": "上传文件为空",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "上传文件格式不正确,文件格式只能为zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "上传文件格式不正确,文件不能没有后缀",
        "Login failed。 Make sure you entered the correct account ID and password。": "登入失敗。確保您輸入了正確的帳戶 ID 和密碼",
        "Date": "日期",
        "Time": "時間",
        "The data will be permanently deleted": "此操作將永久删除當前數據，是否繼續?",
        "Please select an item to delete first": "请先选中一项再删除",
        "Select an item and then delete":"選取項目，然後刪除",
        "Begin Download": "開始下載",
        "Start Download":"開始下載",
        "Password incorrect": "密碼不正確",
        "Password Changed Successfully": "修改密码成功",
        "Display ID or Group ID is empty": "显示器id或组id为空",
        "Select the update package": "選取更新套件",
        "Username already exists": "用戶名已存在",
        "Executing monitor setting command。Please wait 10s before making new changes。": "該顯示器設定命令正在執行中，請等待10s後，再進行新的設定",
        "Close": "關閉",
        "Role does not exist。 Cannot modify role。": "角色不存在，無法修改角色",
        "Unknown Command": "未知命令",
        "Access Token Expired": "訪問權杖已過期",
        "Invalid Refresh Token": "無效的重繪權杖",
        "Missing Request Parameters:": "請求參數缺失:",
        "Incorrect Request Parameter Type:": "請求參數類型錯誤:",
        "Request URL Not Found:": "請求地址不存在:",
        "Incorrect Request Method:": "請求方法不正確:",
        "Log In": "登入",
        "account ID": "帳號",
        "password": "密碼",
        "Update failed": "更新失敗",
        "Reset Password?": "重設密碼？",
        "Logged in successfully": "已成功登入",
        "Please contact the system administrator to reset your password": "請聯絡系統管理員以重設密碼",
        "Retry limit exceeded。 Please try again after 30 minutes": "重试超过5次，请30分钟后再试",
        "Enter the model / host name / firmware version number": "輸入型號/主機名稱/韌體版本號",
        "New Group": "新增群組",
        "Delete Group": "刪除群組",
        "Display Columns": "顯示欄",
        "Collapse": "摺疊",
        "Expand": "展開",
        "Move To": "移至",
        "Export": "导出",
        "Power On": "開啟電源",
        "Power Off": "關閉電源",
        "Screen lock": "屏幕锁定",
        "Unlock screen": "屏幕解锁",
        "Settings": "設定",
        "Export Settings Profiles": "匯出設定檔",
        "Update": "更新",
        "Delete Monitor": "刪除顯示器",
        "Total devices": "裝置總數",
        "Selected devices": "選取的裝置",
        "Update package name": "更新套件名稱",
        "Update Time": "更新時間",
        "Apply to all displays of the same model": "应用于同型号显示器",
        "Display Settings": "顯示設定",
        "Select All": "全選",
        "Settings Profiles": "設定檔",
        "Filename": "檔案名稱",
        "Group": "群組",
        "Monitor Model": "顯示器型號",
        "Special ID": "特殊ID",
        "Host Name": "主機名稱",
        "Host Status": "主機狀態",
        "Monitor Status": "顯示器狀態",
        "Lock Status": "锁定状态",
        "Update Progress": "更新進度",
        "Settings Profile": "設定檔",
        "Tips": "提示",
        "Active Time": "使用時間",
        "Overclock": "超频",
        "Operation successful": "操作成功",
        "Please save data": "請儲存資料",
        "Select the data first": "首先選取資料",
        "Cannot modify when ungrouped": "未分組時無法修改",
        "Deselect All": "取消全選",
        "Select the GAMMA node label value": "選取 GAMMA 節點標籤值",
        "Ungrouped": "未分組",
        "Offline": "離線",
        "Online": "線上",
        "Power on": "開機",
        "Power off": "關機",
        "Locked": "已鎖定",
        "Open": "未鎖定",
        "Open": "已解鎖",
        "Unlocked":"已解鎖",
        "Not connected": "未連線",
        "Connected": "已連線",
        "Set the update start time": "設定更新開始時間",
        "Now": "現在",
        "Set upgrade mode": "设置升级模式",
        "Interactive Mode": "互動模式",
        "Silent mode": "無訊息模式",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "在此模式下，將出現顯示器韌體更新畫面，並要求使用者確認以繼續。使用者可以選擇推遲更新兩次，之後將強制執行更新。",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "在此模式下，當顯示器在線上時，韌體更新將在背景自動執行。使用者不會看到任何通知。更新將在顯示器重新啟動時生效。重新啟動顯示器大約需要幾秒鐘，而且不會影響電腦上正在進行的任何工作",
        "Invalid input": "無效的輸入",
        "Failed to log in": "無法登入",
        "Select your preferred restart time。": "根據您的使用方式選取偏好的重新啟動時間。",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "輸入群組名稱",
        "Apply profile:": "套用設定檔：",
        "A new version is available": "有新版本可用",
        "Restart monitor immediately after update": "更新後立即重新啟動顯示器",
        "Restart when the monitor enters sleep mode": "當顯示器進入睡眠狀態時重新啟動",
        "Restart monitor when it disconnected from all PCs": "當顯示器斷開和所有的PC連接時重啓",
        "Enter the model name": "輸入型號名稱",
        "Create Update Task": "建立更新工作",
        "Update Task List": "更新工作清單",
        "Cancel All": "全部取消",
        "View Details": "檢視詳細資料",
        "Update Details": "更新詳細資料",
        "Update Mode": "更新模式",
        "Update Creation Time": "更新建立時間",
        "Update Start Time": "更新開始時間",
        "Are you sure you want to cancel all tasks?": "您確定要取消所有工作嗎？",
        "Are you sure you want to cancel this task?": "您確定要取消此工作嗎？",
        "Are you sure you want to delete the selected monitor?": "您確定要刪除選取的顯示器嗎？",
        "Confirm to delete all displays?": "确认要删除所有显示器吗？",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "您確定要刪除此項目嗎？（未分組時無法刪除）",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "提示：如果顯示設定中的選項顯示為灰色，可能是受到其他設定的限制。請嘗試調整其他設定以消除限制。",
        "The WebSocket connection has been lost Reconnecting": "WebSocket 連線已遺失。正在重新連接...",
        "The WebSocket connection has been restored": "WebSocket 連接已還原。",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "請將此密碼複製到輸入框中: ",
        "Ebook": "電子書",
        "largest": "最大",
        "Max":"最大",
        "Turn off auto mode": "關閉自動模式",
        "Minimum": "最小",
        "Restore Factory Settings": "還原出廠設定",
        "Scenario Mode": "情景模式",
        "Color Gamut & Color Temperature": "色域色溫",
        "Close PIP, PBP":"關閉",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral": "標準色溫",
        "Panel Native":"原生面板",
        "Neutral(7500K)":"標準色溫",
        "Reddish(6500K)":"暖色溫",
        "Bluish(9300K)":"冷色溫",
        "Reddish":"暖色溫",
        "Bluish":"冷色溫",
        "Warm": "暖色溫",
        "Cool": "冷色溫",
        "Low Blue Light": "低藍光",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Brightness":"亮度",
        "Custom 1": "自訂1",
        "Custom 2": "自訂2",
        "Custom 3": "自訂3",
        "Video Signal": "輸入信號",
        "Game Mode": "遊戲模式",
        "Off": "關閉",
        "off": "關閉",
        "Game 1": "遊戲 1",
        "Game 2": "遊戲 2",
        "Response Time": "回應時間",
        "Normal": "正常",
        "Extreme": "最大",
        "Level 1": "1級",
        "Level 2": "2級",
        "Level 3": "3級",
        "Level 4": "4級",
        "Level 5": "5級",
        "Lan Indicator": "LAN指示燈",
        "Linked": "已連接",
        "No Link": "未連接",
        "Blinking": "通信中",
        "Contrast": "對比度",
        "Smart Light": "智能感光",
        "Volume Control": "音量調節",
        "USB Select": "USB模式",
        "DP Select": "DP模式",
        "Aspect Ratio": "顯示比例",
        "Smart Traffic Light": "智慧交通燈",
        "daisy chain": "菊鏈",
        "Dynamic Contrast": "動態對比度",
        "Smart Energy": "智能能源",
        "Smart Audio": "智能音訊",
        "Distance Warning": "距離警告",
        "Ambient Light Detection": "環境亮度偵測",
        "Enabled Ambient Light Detection": "啟用環境亮度偵測",
        "enabled":"啟用",
        "disabled":"禁用",
        "Waken on Touch": "觸摸喚醒",
        "True Split": "硬分屏",
        "Face Tracking": "人臉追蹤",
        "Audio Smart Switch": "音頻智能開關",
        "Auto-alarm": "自動警示",
        "KVM Switch": "KVM切換",
        "KVM Switch": "KVM切换",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor， keyboard and mouse, Enable switching video， keyboard and mouse simultaneously。 If disabled, only switch keyboard and mouse。": "KVM(鍵盤、視頻、滑鼠)切換功能可使兩台個人電腦共用一套顯示器、鍵盤和滑鼠。可同時切換視頻、鍵盤和滑鼠。如被禁用，則只能切換鍵盤和滑鼠。",
        "Sitting Reminder": "坐姿提醒",
        "Gaming": "遊戲",
        "RGB Gain": "色彩調整",
        "Serial No": "序號",
        "Firmware Version": "韌體版本",
        "Select response time level": "選擇回應時間等級",
        "Enable daisy chain": "啟用菊鏈",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "智慧交通燈是一種免打擾燈，有助於減少分心",
        "Enable/Disable the Audio Smart function": "啟用/禁用音頻智能開關",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "自動警示功能指示顯示器上的攝像頭/麥克風是否正在被使用",
        "Enable Distance Warning": "啟用距離警告",
        "Enable/disable face tracking": "啟用/禁用人臉追蹤功能",
        "Enable Sitting Reminder": "啟用坐姿提醒",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "智慧音訊技術可讓您專注於面前的聲音，以提高聲音清晰度",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "智慧能源技術通過人體檢測感測器來自動管理能耗",
        "Implement PBP through only one cable": "硬分屏幫助你用一根線實現PBP功能",
        "Enable/Disable vPro technology in the monitor": "啟用/禁用vPro功能",
        "Wake system by touch": "通過觸摸屏幕喚醒系統",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "為每台個人電腦設置視頻源和USB源（經由鍵盤和滑鼠所使用）",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM讓您只需同時按下鼠標的左右鍵，即可切換USB信號源",
        "Enable USB charging always on": "始終啟用USB充電",
        "Select DP version": "選擇DP版本",
        "USB Charging": "USB充電",
        "PC": "個人電腦",
        "Double-click the CTRL": "按兩下CTRL鍵",
        "Full Screen": "全屏",
        "Original AR": "原始比例",
        "No scaling": "未縮放",
        "On": "開啟",
        "on":"開啟",
        "Keyboard On": "使用鍵盤",
        "Mouse On": "使用鼠標",
        "Image Creation": "影像創作",
        "Digital Cinema": "數字影院",
        "Video Creation": "視頻創作",
        "Web Browsing": "網頁流覽",
        "Professional Image": "專業圖片",
        "DisplayPort": "DisplayPort",
        "Auto": "自動",
        "Refresh": "重新整理",
        "Search": "搜尋",
        "Record": "記錄",
        "Username": "使用者名稱",
        "Upload Time": "上傳時間",
        "Add Profiles": "新增設定檔",
        "Latest Update Package": "最新更新套件",
        "Upload Update Package": "上傳更新套件",
        "Upload": "上傳",
        "Size": "大小",
        "Upload successful": "上傳成功",
        "Download successful": "下載成功",
        "Refresh successful": "重新整理成功",
        "The upgrade package does not match the device model": "升級包與機型不匹配",
        "Upgrade package does not match the device model":"升級套件與裝置型號不相符",
        "Please enter the setting name": "輸入設定檔名稱",
        "Edit": "編輯",
        "Save": "儲存",
        "Delete": "刪除",
        "Add": "新增",
        "Reset Password": "重設密碼",
        "No": "編號",
        "Full Name": "全名",
        "Role": "角色",
        "Creation Date": "建立日期",
        "Operation": "操作内容",
        "Actions": "操作",
        "The user's initial password is ": "此使用者的初始密碼為 ",
        "The password has been reset to：": "密碼已重設為：",
        "Invalid input。Usernames can only contain numbers and letters。": "無效的輸入。使用者名稱由數字和字母組成",
        "Invalid input。The username must contain 4 to 30 characters。": "無效的輸入。使用者名稱必須包含 4 到 30 個字元",
        "Installation Package": "安裝套件",
        "Operation Date": "操作日期",
        "Actions": "動作",
        "Operator": "操作員",
        "Paging component": "分頁組件",
        "Quick page flipping": "快速翻頁",
        "Current page": "當前頁",
        "Title": "標題",
        "Details": "詳細資料",
        "This is the expanded area": "这是扩展区域",
        "Set Display Column": "设置显示列",
        "Upload file": "上傳文件",
        "Drop-down to expand": "下拉展開",
        "Default": "默認",
        "Default Info": "默認資訊",
        "Personal Center": "個人中心",
        "Personal center image button": "個人中心圖片按鈕",
        "Expandable area": "可展開區域",
        "Update Package Table": "更新包表格",
        "This is the table header": "這是表格標頭",
        "This is the table content": "這是表格內容",
        "UserList Table": "用戶列表表格",
        "Page Up and Down": "上下翻頁",
        "Operation record table": "操作記錄表格",
        "OSD upgrade details": "OSD陞級詳情",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "USB-C 充電",
        "PIP": "PIP",
        "PBP": "PBP",

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "Enter your account ID": "輸入您的帳戶 ID",
        "Please Enter your account id":"請聯絡系統管理員以重設密碼",
        "Enter your password": "輸入您的密碼",
        "Cannot exceed 20 characters": "不能超過 20 個字元",
        "Enter the original password": "請輸入原始密碼",
        "You have still selected the group that the device currently belongs to。 If you want to move the device, please select another group。": "您仍然選取了裝置目前所屬的群組。如果要移動裝置，請選取其他群組。",
        "Enter the filename": "輸入檔案名稱",
        "Update Package Name": "更新套件名稱",
        "Select the date": "選取日期",
        "Select the time": "選取時間",
        "Set the update mode": "設定更新模式",
        "Restart when the monitor is not connected to any computer": "當顯示器未連接至任何電腦時重新啟動",
        "Invalid file format": "無效的檔案格式，僅支援 zip/exe/dmg/app 檔案。",
        "Select a valid file type": "選取有效的檔案類型",
        "The data is being processed。 Please do not submit again。": "資料正在處理中。請勿再次提交。",
        "Enter the profiles name": "輸入設定檔名稱",
        "Enter your username": "輸入您的使用者名稱",
        "Enter your full name": "輸入您的全名",
        "The initial password of this user is:": "此使用者的初始密碼為 ：",
        "Select your role": "選取您的角色",
        "User Profile": "使用者設定檔",
        "Downloading": "正在下載...",
        "Enter the new password again。Two times of new password input is same": "請再次輸入新密碼。新密碼必須與之前輸入的相符。",
        "Request failed with status code 502": "請求失敗，狀態程式碼為502",

        "Please Enter your x": "輸入{param}",
        "Select the x": "選取{param}",
        "Please select the correct file type x": "請選擇正確的檔案類型 {param}",
        "Please select the correct file type": "請選擇正確的檔案類型",
        "Input characters within x characters": "輸入字元在{param}個字元以內",

        "Monitor List":"顯示器清單",
        "List of update packages":"更新套件清單",
        "Settings - Profiles":"設定 - 設定檔",
        "User Management":"使用者管理",
     

        "System abnormality":"系統异常",

        "Upgrade Package Record ID is empty":"升級包記錄不存在",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"更新時間無效，它不能早於當前時間或未來30天以上。",
      
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"請求參數無效：用戶名必須包含4到30個字元",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"請求參數無效：用戶名由數位和字母組成。",
    
        "Request parameter is invalid:Passwordlength must be between 8-16 character":"請求參數無效：密碼長度必須在8-16個字元之間。",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"已編譯的包遺失：該組件有一個尚未上傳的相應bin 請在編譯前上傳。",

        "Request parameter is invalid：Password length must be 8–16 characters":"請求參數無效：密碼長度必須在8-16個字元之間",


        "Illegal request header!": "不合法的要求標頭！",
        "Third-party notifications": "協力廠商通知",
        "Invalid request parameters":"請求參數無效",

        "Export": "匯出",
        "It is already a high-version and there is no need to upgrade":"它已經是高版本，無需陞級",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"通信中"
    }
}